import { useState } from 'react'
import { useClickOutside } from 'hooks/useClickOutside'
import icBulkUpdate from 'assets/images/ic-bulk-update.svg'
import icDown from 'assets/images/ic-chev-down.svg'
import clsx from 'clsx'
import Button from 'components/commons/button'
import Search from 'components/commons/search'
import Table from 'components/commons/table'
import Toast from 'components/commons/toast'
import ViewList from 'components/commons/view-list'
import Modal from 'components/commons/modal'
import icCloseSquare from '../../../assets/images/ic-close-square.svg'

export const TaxPlanningSetting = ({
    dataEmployee,
    optionBulk,
    configTable,
    selectedEmployeeList,
    selectedBulkOption,
    isLoading,
    query,
    modal,
    toastMessage,
    onChangeQuery,
    onSelectItem,
    onBulkUpdate,
    onSetModal,
    onUpdateStatus,
}) => {
    const elementID = 'dropdownBulkUpdate'
    const [showSetting, setShowSetting] = useState(false)
    useClickOutside({ callback: () => showSetting && setShowSetting(false), elementID })

    const onSelect = (e) => {
        setShowSetting(false)
        onBulkUpdate(e)
    }

    return (
        <>
            <div className={'flex flex-row justify-between gap-3 px-6 py-4'}>
                <div className={'flex flex-row gap-3'}>
                    <Search value={query?.search} onSearch={(search) => onChangeQuery({ page: 1, search })} />
                    <ViewList
                        show={modal?.limit}
                        onShow={() => onSetModal({ limit: true })}
                        onClose={() => onSetModal({ limit: false })}
                        value={query?.limit}
                        onSelectSize={(limit) => onChangeQuery({ page: 1, limit })}
                    />
                </div>
                <div className='relative'>
                    <Button
                        title='Bulk Update Status'
                        type='outline'
                        icon={icBulkUpdate}
                        iconAfter={icDown}
                        disabled={!dataEmployee?.total_result}
                        onClick={() => setShowSetting(!showSetting)}
                    />
                    <div
                        id={elementID}
                        className={clsx(
                            'absolute bg-white right-0 mt-1 p-1.5 border border-neutral-20 rounded-lg shadow-sm whitespace-nowrap transition-all duration-200 w-[180px] z-10',
                            showSetting ? 'opacity-100 visible' : 'opacity-0 collapse',
                        )}
                    >
                        {Object.entries(optionBulk).map(([key, value]) => (
                            <div
                                key={key}
                                className='hover:bg-primary-10 capitalize px-4 py-2.5 rounded-lg cursor-pointer transition-all duration-200'
                                onClick={() => onSelect(value)}
                            >
                                {value}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Table
                className='my-3'
                name={configTable.name}
                data={dataEmployee?.results}
                columns={configTable.column}
                size={query?.limit}
                totalPage={dataEmployee?.total_page}
                totalResult={dataEmployee?.total_result}
                currentPage={query?.page}
                onChangePage={(page) => onChangeQuery({ page })}
                onSelectItem={onSelectItem}
                onClickSort={(sortQuery) => onChangeQuery({ ...sortQuery, page: 1 })}
                loading={isLoading}
            />

            {modal?.bulk_update && (
                <Modal dialogClassName='w-full max-w-[350px]' contentClassName='rounded-xl' show={modal?.bulk_update}>
                    <div>
                        <div className={'p-3 flex flex-row items-center justify-between border-b'}>
                            <p className={'font-semibold text-md capitalize'}>Update Status Tax Planning</p>
                            <Button
                                type='outline'
                                shape='circle'
                                size='small'
                                icon={icCloseSquare}
                                onClick={() => onSetModal({ bulk_update: false })}
                            />
                        </div>
                        <div className={'py-4 px-3 flex flex-col space-y-2'}>
                            <p className='font-semibold'>{`Apakah anda yakin ingin merubah status ke ${selectedBulkOption}?`}</p>
                            <p className={'text-neutral-70 mt-3'}>{`${selectedEmployeeList?.length} Data terpilih`}</p>
                        </div>
                        <div className={'px-6 py-3 flex flex-row border-t space-x-3 justify-center'}>
                            <Button type='outline' title='Cancel' onClick={() => onSetModal({ bulk_update: false })} />
                            <Button title='Submit' onClick={onUpdateStatus} />
                        </div>
                    </div>
                </Modal>
            )}
            
            <Toast show={modal?.toast} message={toastMessage} onClose={() => onSetModal({ toast: false })} />
        </>
    )
}
